import { AreaSelection } from "@/components/Filter/areaSelection";
import { DateRangeSelection } from "@/components/Filter/dateRangeSelection";
import { GroupSelection } from "@/components/Filter/groupSelection";
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import { SaveFilterAndSearch } from "@/components/Filter/saveFilterAndSearch";
import { TypeSelection } from "@/components/Filter/typeSelection";
import { setSelectedProduct } from "@/features/dataTableSlice";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";

import React from "react";
import { useSelector } from "react-redux";

import PublishIcon from "@mui/icons-material/Publish";
export default function CompareSalesToolBar(props) {
  const dispatch = useDispatch();
  const {
    productSelecter,
    handleImportProduct,
    handleImportShop,
    fetchData,
    loading,
    productData,
  } = props;
  const combineSameSku = useSelector((state) => state.dataTable.combineSameSku);
  const typeGrouping = useSelector((state) => state.dataTable.typeGrouping);

  const [open, setOpen] = React.useState(false);
  const selectedProduct = useSelector(
    (state) => state.dataTable.selectedProduct
  );
  const anchorRef = React.useRef(null);
  const importProductRef = React.useRef(null);
  const importShopRef = React.useRef(null);
  const handleCloseSaveAction = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return (
    <>
      <GridToolbarContainer>
        {productSelecter && (
          <Box>
            <FormControl sx={{ m: 1, width: 200 }}>
              <ProductAutoComplete
                selectByCategory
                id={"product-auto-0"}
                multiple
                fullWidth
                productOptions={productData}
                handleOnChange={(value) => {
                  dispatch(setSelectedProduct({ value: value }));
                }}
                selectedValue={selectedProduct}
                error={selectedProduct.length <= 0}
              ></ProductAutoComplete>
            </FormControl>
            <TypeSelection />
            {typeGrouping === "shop" && <AreaSelection />}
            <GroupSelection />
            <DateRangeSelection />
            <SaveFilterAndSearch
              fetchData={fetchData}
              loading={loading}
              combineSameSku={combineSameSku}
            />
          </Box>
        )}
      </GridToolbarContainer>
      <GridToolbarContainer>
        <GridToolbar
          csvOptions={{
            utf8WithBom: true,
          }}
        />
        <GridToolbarContainer>
          <Button
            ref={anchorRef}
            component="label"
            onClick={() => {
              setOpen(true);
            }}
          >
            <PublishIcon fontSize="small" />
            IMPORT
            {/* <input
              hidden
              type={"file"}
              id={"import"}
              accept={".xlsx"}
              onChange={async (e) => {
                handleImport(e);
              }}
            /> */}
          </Button>
          <Popper
            sx={{
              zIndex: 1,
            }}
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseSaveAction}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      <MenuItem
                        onClick={() => {
                          importProductRef.current.click();
                        }}
                      >
                        <input
                          ref={importProductRef}
                          hidden
                          type={"file"}
                          id={"importProduct"}
                          accept={".xlsx"}
                          onChange={async (e) => {
                            handleImportProduct(e);
                          }}
                        />
                        Import Weekly Report
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          importShopRef.current.click();
                        }}
                      >
                        <input
                          ref={importShopRef}
                          hidden
                          type={"file"}
                          id={"importShop"}
                          multiple
                          accept={".xlsx"}
                          onChange={async (e) => {
                            handleImportShop(e);
                          }}
                        />
                        Import Shop Report
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </GridToolbarContainer>
        {/* <GridToolbarContainer>
          <ButtonGroup variant="contained" aria-label="Basic button group">
            <Button
              variant={selectedMode.includes("all") ? "contained" : "outlined"}
              onClick={() => {
                handleSwitchMode("all");
              }}
            >
              All
            </Button>
            <Button
              variant={
                selectedMode.includes("promoter") ? "contained" : "outlined"
              }
              onClick={() => {
                handleSwitchMode("promoter");
              }}
            >
              Promoter
            </Button>
          </ButtonGroup>
        </GridToolbarContainer> */}
      </GridToolbarContainer>
    </>
  );
}
